import React from "react"

import { Col, Row, Card } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useSubTask from '../hooks/useSubTask';
import '../css/task.css'
import Store from "../store/Store";

const Subtask = ({ task, subTask }) => {
    const taskForSubTasks = task || { sub_tasks: [] };
    const { subTaskState, toggleSubTask } = useSubTask(task.guid, taskForSubTasks);
    const { user } = Store.getState();
    const isOpen = subTaskState[subTask.id] || false;

    // console.log(item);

    return (
        <Card border="light" className={`task mb-2`} key={'subtask_' + subTask.id}>
            <Card.Header className={`${!isOpen ? "round" : ""}`} onClick={() => toggleSubTask(subTask.id)} style={{ cursor: 'pointer' }}>
                <strong>{subTask.task_name === 'Munkaerő' ? `${subTask.task_name} - ${subTask.item_name}` : subTask.task_name}</strong>
                <span className="btn button btn-flt-r"><FontAwesomeIcon
                    icon={isOpen ? "fa-solid fa-chevron-up" : "fa-solid fa-chevron-down"}
                />
                </span>
            </Card.Header>
            {isOpen && (
                <Card.Body>
                    <div>
                        {subTask.warehouse_name !== 'Munkaerő' &&
                            <Row>
                                <Col><span><strong>Raktár</strong></span></Col>
                                <Col><span>{subTask.warehouse_name}</span></Col>
                            </Row>
                        }
                        {subTask.task_name !== 'Munkaerő' &&
                            <Row>
                                <Col><span><strong>Megnevezés</strong></span></Col>
                                <Col><span>{subTask.item_name}</span></Col>
                            </Row>
                        }

                        {user?.permissions?.includes('pwaViewCosts') && (
                            <Row>
                                <Col><span><strong>Költség/ha</strong></span></Col>
                                <Col><span>{subTask.cost}</span></Col>
                            </Row>
                        )}

                        {subTask.amount && <Row>
                            <Col><span><strong>Mennyiség/ha</strong></span></Col>
                            <Col><span>{subTask.amount}</span></Col>
                        </Row> }
                        {subTask.total_amount && <Row>
                            <Col><span><strong>Összmennyiség</strong></span></Col>
                            <Col><span>{subTask.total_amount}</span></Col>
                        </Row>}

                        {user?.permissions?.includes('pwaViewCosts') && (
                            <Row>
                                <Col><span><strong>Teljes költség</strong></span></Col>
                                <Col><span>{subTask.total_cost}</span></Col>
                            </Row>
                        )}
                    </div>
                </Card.Body>
            )}
        </Card>
    );
};
export default Subtask;